module.exports = __webpack_public_path__ + "assets/img/group-logo-c8a60a42.png";